import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

/**
 * 全局页脚
 * - 移除脚手架默认的 GitHub / Ant Design 外链
 * - 保留版权信息
 */
const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="统一用户中心"
      links={false}
    />
  );
};

export default Footer;
